import { RootState } from "../../../../index";

export const WorkspaceData = (state: RootState) => state?.settingsWorkspace?.data?.workspaceData;